import React, { useEffect, useState, useContext, useRef } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import FullCreateStyleModal from "pages/de/project/create-project/components/FullCreateStyleModal";

const EmptyStyleCard = ({ content = null, refresh = () => {}, size = "md" }) => {
  const [createStyleVisible, setCreateStyleVisible] = useState(false);

  const navigate = useNavigate();

  let styles = {
    cardWidth: 260,
    cardHeight: 425,
  };
  if (size == "sm") {
    styles = {
      cardWidth: 220,
      cardHeight: 345,
    };
  }
  const handleAfterOk = (newStyle) => {
    console.log(newStyle);
    let id = newStyle?.data?.product?.id;
    if (id) {
      navigate(`/workspace/styles-master?id=${id}`);
    }
  };

  return (
    <SuiBox sx={{ my: 2, mx: 1 }}>
      <SuiBox
        sx={{
          border: "1px dashed",
          borderWidth: ({ borders }) => borders.borderWidth[2],
          borderColor: ({ borders }) => borders.borderColor,
          cursor: "pointer",
          height: styles.cardHeight,
          width: styles.cardWidth,
          borderRadius: 4,
        }}
      >
        {content ? (
          content
        ) : (
          <SuiBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ height: "100%", width: "100%" }}
            onClick={() => setCreateStyleVisible(true)}
          >
            <AddIcon fontSize="small" />
            <SuiTypography variant="body2" textTransform="uppercase" fontWeight="bold">
              Create Style
            </SuiTypography>{" "}
          </SuiBox>
        )}
      </SuiBox>
      {createStyleVisible ? (
        <FullCreateStyleModal
          handleClose={() => setCreateStyleVisible(false)}
          visible={createStyleVisible}
          isEdit={false}
          handleRefresh={refresh}
          handleAfterOk={handleAfterOk}
        />
      ) : null}
    </SuiBox>
  );
};

export default EmptyStyleCard;
